<template>
  <div class="purchase_popup">
    <b-modal
      ok-only
      ok-title="Fermer"
      size="lg"
      id="purchase-popup"
      ref="purchase-popup"
      title="Demande de formation"
    >
      <b-container>
        <b-form @submit.prevent="onSubmit">
          <b-alert show variant="primary">
            <span class="pull-left demand-text">
              Faire une demande ne vous engage en rien, il s'agit juste
              d'engager un premier contact direct avec moi.
            </span>
          </b-alert>
          <b-row>
            <b-col lg="6" xl="6" sm="12">
              <!-- Request type -->
              <b-form-group
                id="company-group"
                label=""
                label-for="company"
                description=""
              >
                <b-form-select
                  v-model="selectedOption"
                  :options="form.options"
                  @change="changeRequestType"
                ></b-form-select>
              </b-form-group>
              <!-- Entreprise -->
              <b-form-group
                id="company-group"
                label=""
                label-for="company"
                description=""
              >
                <b-form-input
                  id="company"
                  v-model="form.company"
                  type="text"
                  required
                  placeholder="Entreprise"
                  class="form-elmt"
                ></b-form-input>
              </b-form-group>
              <!-- company city -->
              <b-form-group
                id="city-group"
                label=""
                label-for="city"
                description=""
              >
                <b-form-input
                  id="city"
                  v-model="form.city"
                  type="text"
                  placeholder="Lieu"
                  class="form-elmt"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" xl="6" sm="12">
              <!-- Nom contact -->
              <b-form-group
                id="name-group"
                label=""
                label-for="name"
                description=""
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  required
                  placeholder="Nom et prénom du contact"
                  class="form-elmt"
                ></b-form-input>
              </b-form-group>
              <!-- email contact -->
              <b-form-group
                id="email-group"
                label=""
                label-for="email"
                description=""
              >
                <b-form-input
                  id="email"
                  v-model="form.email"
                  type="email"
                  required
                  placeholder="Adresse email"
                  class="form-elmt"
                ></b-form-input>
              </b-form-group>
              <!-- contact phone -->
              <b-form-group
                id="phone-group"
                label=""
                label-for="phone"
                description=""
              >
                <b-form-input
                  id="phone"
                  v-model="form.phone"
                  type="tel"
                  placeholder="Numéro de téléphone"
                  class="form-elmt"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Checkbox PDF -->
          <b-form-group v-show="!requestPDFDisabled">
            <b-form-checkbox
              id="requestPDF"
              v-model="form.requestPDF"
              name="requestPDF"
              value="true"
              unchecked-value="false"
              :disabled="requestPDFDisabled"
            >
              Recevoir le PDF de la formation
            </b-form-checkbox>
          </b-form-group>

          <!-- Message -->
          <b-form-textarea
            id="message"
            v-model="form.message"
            placeholder="Message"
            required
            rows="6"
            max-rows="8"
            class="form-elmt"
          >
            <!-- Bouton d'envoi -->
          </b-form-textarea>
          <b-button
            class="purchase-send-btn"
            squared
            size="lg"
            :variant="formSend.btnVariant"
            type="submit"
            :disabled="formSend.isSent"
          >
            <span v-if="!formSend.isSending">{{ formSend.btnMessage }}</span>
            <b-spinner v-else variant="warning" label="Spinning"></b-spinner>
          </b-button>
          <br />
          <b-alert :show="formSend.displayPDFSentMessage" variant="success"
            ><center>{{ formSend.PDFSentMessage }}</center></b-alert
          >
        </b-form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import MailService from "@/services/MailService";

export default {
  name: "PurchasePopup",
  data() {
    return {
      selectedOption: "formation",
      requestPDFDisabled: false,
      formSend: {
        isSent: false,
        isSending: false,
        btnVariant: "warning",
        btnMessage: "Envoyer",
        PDFSentMessage:
          "Vous recevrez les plans de formation sous peu (Pensez à vérifier vos spams)",
        displayPDFSentMessage: false,
      },
      form: {
        company: "",
        name: "",
        email: "",
        message: "",
        phone: null,
        city: "",
        requestPDF: false,
        options: [
          {
            value: "formation",
            text: "Formation",
          },
          {
            value: "coaching",
            text: "Coaching",
          },
        ],
      },
    };
  },
  props: {
    requestType: {
      type: String,
    },
  },
  mounted() {
    this.mailService = new MailService();
    this.selectedOption = this.requestType;
    this.changeRequestType();
  },
  watch: {
    requestType: function(newVal) {
      this.selectedOption = newVal;
      this.changeRequestType();
    },
  },
  methods: {
    onSubmit() {
      this.formSend.isSending = true;
      this.formSend.btnVariant = "info";

      const payload = {
        company: this.form.company,
        name: this.form.name,
        email: this.form.email,
        message: this.form.message,
        phone: this.form.phone,
        city: this.form.city,
        requestPDF: this.form.requestPDF,
        selectedOption: this.selectedOption,
      };

      setTimeout(() => {
        console.log("is checked", this.form.requestPDF);
        this.mailService
          .sendPurchaseEmail(payload)
          .then(() => {
            this.formSend.btnVariant = "success";
            this.formSend.isSent = true;
            this.formSend.btnMessage = "Message envoyé !";
            this.formSend.displayPDFSentMessage =
              this.form.requestPDF == "true" ? true : false;
          })
          .catch(() => {
            this.formSend.btnVariant = "danger";
            this.formSend.btnMessage = "Une erreur s'est produite";
          });
        this.formSend.isSending = false;
      }, 300);
    },
    changeRequestType: function() {
      this.requestPDFDisabled =
        this.selectedOption == "coaching" ? true : false;
      this.form.requestPDF =
        this.selectedOption == "coaching" ? false : this.form.requestPDF;
    },
  },
};
</script>
